(function(){
  var drawer=document.getElementById('cd');
  var root=drawer?(drawer.getAttribute('data-root')||'/'):'/';
  function inner(){return document.getElementById('cd-inner')}
  function setCount(n){document.querySelectorAll('[data-cart-dot]').forEach(function(e){e.hidden=!(n>0)})}
  function render(html){
    html=html.replace(/loading="lazy"/g,'loading="eager"');
    var d=new DOMParser().parseFromString(html,'text/html');
    var n=d.getElementById('cd-inner');
    if(n&&inner()){inner().innerHTML=n.innerHTML;setCount(parseInt(n.getAttribute('data-count'),10)||0)}
  }
  function refresh(){
    return fetch(root+'?sections=cart-drawer',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){render(j['cart-drawer'])});
  }
  function open(){if(!drawer)return;drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('cd-lock');var x=drawer.querySelector('.cd__x');if(x)x.focus()}
  function close(){if(!drawer)return;drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('cd-lock')}
  function bump(){document.querySelectorAll('.tools .cart').forEach(function(c){c.classList.remove('bump');void c.offsetWidth;c.classList.add('bump')})}
  function change(key,qty){
    return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){return refresh()});
  }
  function applyCode(box){
    var inp=box.querySelector('.cdcode__in');
    var code=(inp.value||'').trim();
    if(!code)return;
    var btn=box.querySelector('[data-cd-apply]');
    var msg=box.querySelector('.cdcode__msg');
    btn.disabled=true;msg.hidden=true;
    fetch('/discount/'+encodeURIComponent(code),{credentials:'same-origin'})
      .then(function(){return fetch('/cart.js',{credentials:'same-origin'})})
      .then(function(r){return r.json()})
      .then(function(c){
        var lc=code.toLowerCase();
        var apps=(c.cart_level_discount_applications||[]).map(function(a){return String(a.title||'').toLowerCase()});
        (c.items||[]).forEach(function(i){(i.discounts||[]).forEach(function(d){apps.push(String(d.title||'').toLowerCase())})});
        if(apps.indexOf(lc)>-1){
          if(box.closest('#cd')){refresh()}else{location.reload()}
        }else{
          msg.textContent=box.getAttribute('data-fail')||'';msg.hidden=false;btn.disabled=false;
        }
      })
      .catch(function(){btn.disabled=false});
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cd-close]')){close();return}
    var ap=e.target.closest('[data-cd-apply]');
    if(ap){e.preventDefault();var box=ap.closest('.cdcode');if(box)applyCode(box);return}
    var q=e.target.closest('[data-cd-qty]');
    if(q){e.preventDefault();q.disabled=true;change(q.getAttribute('data-cd-qty'),parseInt(q.getAttribute('data-q'),10));return}
    var o=e.target.closest('[data-cd-open]');
    if(o&&drawer){e.preventDefault();open();refresh();return}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&drawer&&drawer.classList.contains('open'))close();
    if(e.key==='Enter'&&e.target&&e.target.classList&&e.target.classList.contains('cdcode__in')){e.preventDefault();var box=e.target.closest('.cdcode');if(box)applyCode(box)}
  });
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.matches||!f.matches('form[action$="/cart/add"]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]');
    if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(btn)btn.disabled=false;
        if(!res.ok){alert(res.j.description||res.j.message||'Error');return}
        if(!drawer){location.href=root+'cart';return}
        return refresh().then(function(){bump();open()});
      })
      .catch(function(){if(btn)btn.disabled=false;f.submit()});
  });
})();
